// frontend/src/api/jobs.js

import { httpJson } from "./client";
import { standardizeCapitalization } from "../utils/textFormat";

export async function listJobs({ limit = 200, offset = 0 } = {}) {
  const params = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  }).toString();
  const data = await httpJson(`/jobs?${params}`, { method: "GET" });
  return Array.isArray(data) ? data : [];
}

export async function createJob(input) {
  const src = input && typeof input === "object" && !Array.isArray(input) ? input : { name: input };
  const payload = {
    name: standardizeCapitalization(src.name || "") || "Untitled Job",
  };
  ["notes", "intake_source", "intake_json"].forEach((key) => {
    if (src[key] !== undefined && src[key] !== null) payload[key] = src[key];
  });
  return await httpJson("/jobs", {
    method: "POST",
    body: payload,
  });
}

export async function getJob(jobId) {
  const id = (jobId || "").trim();
  return await httpJson(`/jobs/${encodeURIComponent(id)}`, { method: "GET" });
}

export async function deleteJob(jobId) {
  const id = (jobId || "").trim();
  if (!id) throw new Error("jobId is required");
  return await httpJson(`/jobs/${encodeURIComponent(id)}`, { method: "DELETE" });
}

export async function deleteJobsBulk(jobIds = []) {
  const ids = Array.isArray(jobIds)
    ? jobIds.map((x) => String(x || "").trim()).filter(Boolean)
    : [];
  if (ids.length < 1) {
    return { deleted_ids: [], not_found_ids: [] };
  }
  return await httpJson("/jobs/bulk-delete", {
    method: "POST",
    body: { ids },
  });
}
